###
  CRUD Sites template
###

class INTENT.templates.CrudSite

  @get_type_list: (options, active = null) ->
    options_list = ""

    for ex_type, ex_options of options
      value = ex_type
      label = ex_options.label || value

      unless active
        active_option = false
      else
        active_option = (active == value)

      options_list = options_list + @get_option_element value, label, active_option

    return options_list

  @get_time_list: (options, active = null) ->
    options_list = ""

    for ex_type, ex_options of options
      value = ex_type
      label = ex_options.label || value

      unless active
        active_option = false
      else
        active_option = (active == value)

      options_list = options_list + @get_option_element value, label, active_option

    return options_list

  @get_option_element: (value, label = null, selected = true) ->
    if selected == true then selected = " selected"
    unless label then label = value

    """
    <option value="#{value}"#{selected}>#{label}</option>
    """

  @get_input_element: (id, label, name, value = '', ex_attributes = '') ->
    """
    <div style='margin-bottom: 3px'>
      <!--<span>#{label}</span><br>-->
      <input data-widget-crud-site-rule-additional-field #{ex_attributes} name="conversion_rules[#{id}][#{name}]" value="#{value}" type="text" placeholder="#{label}" class="col-md-12 form-control" style="width:100%; min-width:170px;">
    </div>
    """

  @get_deduplication_window_types: (selected_type = 'disabled') ->
    types = {
      "disabled": "OFF",
      "sec": __('seconds'),
      "min": __('minutes'),
      "hour": __('hours'),
      "day": __('days')
    }

    options = ""
    for key, value of types
      selected = if key is selected_type then "selected" else ""
      options += "<option value='#{key}' #{selected}>#{value}</option>"
    return options

  @get_explicit_groups: (selected_type = 'disabled') ->
    types = {
      '': '---'
      'video_start': __('sites.conversion_rules.table.explicit_group.video_start')
      'video_complete': __('sites.conversion_rules.table.explicit_group.video_complete'),
      'view_depth': __('sites.conversion_rules.table.explicit_group.view_depth'),
    }

    options = ""
    for key, value of types
      selected = if key is selected_type then "selected" else ""
      options += "<option value='#{key}' #{selected}>#{value}</option>"
    return options

  @get_input_additional: (id, values, fields = null) ->
    unless fields
      return "<div style='color: darkgray; margin-top: 3px'>None</div>"
    else
      result = ""
      for ex_type, ex_field of fields
        name = ex_type
        label = ex_field.label
        default_val = ex_field.default || ""
        value = values[name] || default_val

        ex_attributes = ''
        if ex_field.allow_empty
          ex_attributes += 'allow-empty'

        result = result + @get_input_element id, label, name, value, ex_attributes

      return result

  @get_conversion_rule: (id, options, values = {type: null}, show_cpa_controls = false) ->
    type = values.type || null
    group = values.explicit_group || null
    name = values.name || ""
    max_conversions_number = values.max_conversions_number || ""
    deduplication_window_seconds = values.deduplication_window_seconds || ""
    #MARUI-2568 убираем возможность построения cpa модели, только если достаточно конверсий. Теперь модель можно построить всегда.
    #conversion_status = values.conversion_status || ""
    build_cpa_model = values.build_cpa_model || false

    options_list = @get_type_list options, type
    deduplication_window_types = @get_deduplication_window_types values.deduplication_window_type
    deduplication_window_disabled = if values.deduplication_window_type is 'disabled' or !values.deduplication_window_type then 'disabled' else ''

    if type
      additional_fields = options[type]['fields']
    else
      tr = $(options_list).eq(0).attr "value"
      additional_fields = options[tr]['fields']

    additional = @get_input_additional id, values, additional_fields

    build_model = "";
    if show_cpa_controls
      #MARUI-2568 убираем возможность построения cpa модели, только если достаточно конверсий. Теперь модель можно построить всегда.
      #build_model = __('sites.conversion_rules.table.build_cpa_model.status.NO_CONVERSIONS')
      #if conversion_status
      #  if conversion_status == 'FEW_CONVERSIONS'
      #    build_model = __('sites.conversion_rules.table.build_cpa_model.status.FEW_CONVERSIONS')
      #  if conversion_status == 'FEW_IMPRESSIONS'
      #    build_model = __('sites.conversion_rules.table.build_cpa_model.status.FEW_IMPRESSIONS')
      #  if conversion_status == 'ENOUGH_CONVERSIONS'
      #    checked = if build_cpa_model then 'checked="checked"' else ''
      #    build_model = "<input type=\"checkbox\" #{checked} class=\"on-off build-cpa-model\" name=\"conversion_rules[#{id}][build_cpa_model]\" value=\"true\" data-switch-target/>";
      checked = if build_cpa_model then 'checked="checked"' else ''
      build_model = "<input type=\"checkbox\" #{checked} class=\"on-off build-cpa-model\" name=\"conversion_rules[#{id}][build_cpa_model]\" value=\"true\" data-switch-target/>";
    build_model = "<td>#{build_model}</td>"

    explicit_groups = "";
    if show_cpa_controls
      explicit_groups_list = @get_explicit_groups group
      explicit_groups = """<td>
        <select name=\"conversion_rules[#{id}][explicit_group]\" class='form-control select2-init' style='width:150px'>
          #{explicit_groups_list}
        </select>
      </td>"""

    """
    <tr data-widget-crud-site-rule-id="#{id}">
        <td class='white-column'>
            <input #{if name then 'readonly="readonly"' else ''} data-widget-crud-site-rule-name name="conversion_rules[#{id}][name]" value="#{name}" type="text" class="col-md-12 form-control #{if name then 'disabled' else ''}" style='width:170px' >
        </td>
        <td class='white-column'>
            <select data-widget-crud-site-rule-types name="conversion_rules[#{id}][type]" class='form-control select2-init' style='width:200px'>
              #{options_list}
            </select>
        </td>
        <td class='white-column' data-widget-crud-site-rule-additional style='width:70%'>
            #{additional}
        </td>
        <td class='white-column'>
          <div class='select2-input-group' style="width:175px">
            <div>
              <input data-widget-crud-site-rule-deduplication_window_seconds
                     name="conversion_rules[#{id}][deduplication_window_seconds]"
                     value="#{deduplication_window_seconds}"
                     type="number" class="col-md-12 form-control"
                     #{deduplication_window_disabled}
                     style="width:80px"/>
            </div>
            <div style="width:90px">
              <select class='form-control deduplication-window select2-init' name="conversion_rules[#{id}][deduplication_window_type]">
                  #{deduplication_window_types}
              </select>
            </div>
          </div>
        </td>
        <td class='white-column'>
          <div>
              <input data-widget-crud-site-rule-max_conversions_number
                     name="conversion_rules[#{id}][max_conversions_number]"
                     value="#{max_conversions_number}"
                     type="number" min="0" step="1"
                     class="col-md-12 form-control"
                     style='width:130px'/>
            </div>
        </td>
        #{explicit_groups}
        #{build_model}
        <td>
            <a href="javascript:void(0)" data-widget-crud-site-rule-remove class='remove-on-disabled'><i class="glyphicon glyphicon-remove"></i></a>
        </td>
    </tr>
    """
